export const DEBOUNCE_VALIDATION_MS = 1000;
